<template>

  <form @submit.prevent="save">

    <card class="p-col-12" :header="$t(cardHeader)">

      <coff-input-text class="p-col-12" v-if="client" label="forms.add-service.client" v-model="client.name" :disable="true"/>

      <coff-input-text v-model="form.amount" label="forms.add-service.amount" class="p-col-12 p-md-6 p-lg-4" :error="validation.amount" />

      <coff-input-auto-complete v-if="typeServices" v-model="form.typeService" label="forms.add-service.type-service" class="p-col-12 p-md-6 p-lg-4" :itens="typeServices" field="name" :func-suggestions="searchTypeService" :error="validation.typeService" :dropdown="true"/>

      <div class="p-col-12 p-md-6 p-lg-4 p-mt-4">
        <strong>{{$t('forms.add-service.total')}}:</strong> {{$n(form.price || 0, 'currency')}} <a class="p-link" @click.prevent="calculatePriceTypeOfServiceProtocol">{{$t('forms.add-service.calculate')}}</a>
      </div>

      <coff-input-auto-complete v-model="form.underAgeClient" label="forms.add-service.under-age-client" class="p-col-4" :itens="clients" field="name" :func-suggestions="searchClient"/>

      <div class="p-col-12">
        <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
      </div>

    </card>

  </form>

</template>

<script>
import TypeServiceBusiness from "@/business/TypeServiceBusiness";
import ValidationUtils from "@/utils/ValidationUtils";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import Utils from "@/utils/Utils";
import ClientBusiness from "@/business/ClientBusiness";

export default {
  name: "CardFormService",

  async created(){
    this.typeServices =  await this.searchTypeService();
  },

  async mounted(){
    this.clients =  await ClientBusiness.getAll();
    if(this.paramComponent) this.form = Utils.safetyClone(this.paramComponent);
    if(this.paramComponent?.client) this.client = this.paramComponent?.client;
  },

  props:{
    protocol: {type: Object, default: () => {}},
    paramComponent: {type: Object, default: null},
  },

  computed:{

    cardHeader(){
      return `forms.add-service.${this.form.id ? 'edit' : 'add'}-card-header`;
    }

  },

  data(){
    return {
      form: {},
      validation: {
        typeService: false,
        amount: false,
      },
      typeServices: null,
      client: null,
      clients: [],
    }
  },

  methods:{

    cleanForm(){
      this.form = {};
      this.validation = {
        typeService: false,
        amount: false,
      };
    },

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        if(Utils.isEmptyNullOrUndefined(this.form.underAgeClient)) delete this.form.underAgeClient;
        await this.calculatePriceTypeOfServiceProtocol();
        if(this.client) this.form.client = this.client;
        const response = await ProtocolBusiness.saveTypeOfServiceProtocol(this.form, this.protocol.id, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.$emit('success', response);
          ToastMessageBusiness.showSuccess();
          this.cleanForm();
        }
      }
    },

    async calculatePriceTypeOfServiceProtocol(){
      const price = await ProtocolBusiness.calculatePriceTypeOfServiceProtocol(this.protocol.id, this.form);
      if(price){
        this.$set(this.form, 'price', price);
      }
    },

    async searchTypeService(name){
      return await TypeServiceBusiness.searchByName(name);
    },

    async searchClient(name){
      return await ClientBusiness.search(name);
    },

  }

}
</script>

<style scoped>

</style>